// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabs_tabsContainer__shO2m","tabsHeader":"tabs_tabsHeader__uUU9t","tab":"tabs_tab__cjDAX","activeTab":"tabs_activeTab__mO_bF","tabContent":"tabs_tabContent__KNYx4"};